import React, { useCallback, useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useCommissions } from '../../_hocs/withCommissions';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import SelectedItemsPanel from '../../_partials/SelectedItemsPanel';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import LoadingIndicator from '../../../LoadingIndicator';
import Grid from '../../../Grid';
import { MeasuredCookieType } from '../../../Measured';
import ShopThumb from '../../../DeviationViews/Thumb/Shop/ShopThumb';
import s from './CommissionSelector.scss';
var CommissionSelector = function () {
    var isMobile = useContext(MobileContext);
    var _a = useCommissions(), isCommissionStreamInitialized = _a.isCommissionStreamInitialized, commissions = _a.commissions, isFetchingCommissions = _a.isFetchingCommissions, hasMoreCommissions = _a.hasMoreCommissions, fetchMoreCommissions = _a.fetchMoreCommissions;
    var fetchMoreIfNeeded = useCallback(function () {
        if (!hasMoreCommissions || isFetchingCommissions) {
            return;
        }
        fetchMoreCommissions();
    }, [hasMoreCommissions, isFetchingCommissions, fetchMoreCommissions]);
    var renderGridElement = function (_a) {
        var index = _a.index, width = _a.width, style = _a.style;
        var commission = commissions[index];
        return (React.createElement("div", { style: style },
            React.createElement(SelectableDeviationWrapper, { key: commission.deviationId, deviation: commission },
                React.createElement(ShopThumb, { addLink: false, width: width, deviation: commission }))));
    };
    var renderContent = function () {
        if (!commissions.length &&
            isCommissionStreamInitialized &&
            !isFetchingCommissions) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            isCommissionStreamInitialized && commissions.length > 0 && (React.createElement(Grid, { className: s['root'], breakpoints: [
                    { maxWidth: 9999, elementWidth: 330, elementHeight: 340 },
                ], cookieType: MeasuredCookieType.GALLECTION_EXPLORER, elementCount: commissions.length, renderElement: renderGridElement, spacing: isMobile ? 10 : 16, enableScrollOptim: false })),
            (!isCommissionStreamInitialized || isFetchingCommissions) && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !fetchMoreCommissions }))));
    };
    return (React.createElement(PopupInnerLayout, { headerExtrasBottomZone: React.createElement(SelectedItemsPanel, null), scrollableContent: renderContent(), onScrolledToBottom: fetchMoreIfNeeded, onNotScrollable: fetchMoreIfNeeded }));
};
CommissionSelector.displayName = 'CommissionSelector';
export default CommissionSelector;
//# sourceMappingURL=CommissionSelector.js.map